import React, { useCallback } from 'react';
import { Group } from '@landr/maestro';
import { ModifiersPayload } from 'controllers/SearchController/types';
import { FiltersParams } from 'types/params';
import { toUnicodeKeyRoot } from 'types/enums';
import ActiveFilter from '../components/ActiveFilter';

const getActiveKey = (
    root: string | null,
    removeFilter: (modifiers: ModifiersPayload[]) => void,
) => {
    const onClear = useCallback(() => {
        root && removeFilter([[FiltersParams.keyrootnote, root]]);
    }, [removeFilter, root]);

    if (!root) {
        return null;
    }

    const normalizedFilter = toUnicodeKeyRoot(root);

    return (
        <Group.Item
            key={`filter-${FiltersParams.keyrootnote}-${normalizedFilter}`}
        >
            <ActiveFilter onClick={onClear} filter={normalizedFilter} />
        </Group.Item>
    );
};

export default getActiveKey;
